import React, { useEffect, useRef, useState } from "react";
import { Badge } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  UpdateFav,
  updateFavProduct,
} from "../../../Redux/Action/updateFavAction";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../../AxiosInstance";
import { URLS } from "../../../API/API endpoints";
import { toast } from "react-toastify";
import { removeFav } from "../../../Redux/Action/removeFavAction";
import { Link } from "react-router-dom";
import { detectWebDeviceType } from "../../../utils";
import dummy_image from "../../../assets/no-image.webp";
import { info_icon } from "../../../assets";
import HamperInfoModal from "../../Modal/HamperInfoModal";
import ProductExpiryModal from "../../Modal/ProductExpiryModal";

const ProductCard = ({
  product,
  onClick,
  isFocused,
  isSelectActive,
  isSelected,
  onSelectToggle,
  activeGroupId,
}) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.login?.user?.result);
  const [loading, setLoading] = useState(false);

  const productTax = product?.vat_details;
  const totalProductTax = (product.sale_price * productTax?.tax_rate_percent)/100;
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [expiryModal, setExpiryModal] = useState(false);
const [selectedHamper, setSelectedHamper] = useState(null);

  // const showFav = useSelector(
  //   (state) => state?.login?.user?.result?.is_favorite_show
  // );

  const showFav = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_favorite_show,
  );
  const negativeSale = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_allow_negative_sale,
  );
  const showAddedExclusivePrice = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_tax_price_inclusive
  );

  const isETAenabled = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_eta_enabled
  );
  const toggleFavorite = async (event) => {
    setLoading(true);
    const is_favorite = product.is_favorite;
    const requestData = {
      company_id: userData?.company_id,
      product_id: product?.prod_id,
      action: is_favorite ? "remove" : "add",
    };
    try {
      const response = await axiosInstance.post(
        process.env.REACT_APP_API_URL_OLD + URLS.UPDATE_FAV_PROD,
        requestData,
      );

      if (response.data.result.status_code === 200) {
        const updatedProduct = { ...product, is_favorite: !is_favorite };
        product.is_favorite = !is_favorite;

        dispatch(UpdateFav(updatedProduct));

        if (response.data.result.message.includes("removed")) {
          dispatch(removeFav(true));
          toast.error(t("Product removed from favorites"));
        } else if (response.data.result.message.includes("added")) {
          toast.success(t("Product added to favorites"));
        }
      } else {
        toast.error("Failed to update favorite");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while updating favorite");
    } finally {
      setLoading(false);
    }
  };

  // console.log("isSelectActive", isSelectActive);

  const openProductInfo = (product) => {
  setSelectedHamper(product);
  setOpenInfoModal(true);
};

  return (
    <>
      <div
        className={`relative flex flex-col mt-3 mb-1 me-2 w-[15.5%] 2xl:w-[12.5%] h-48 transform transition-transform duration-300 ${
          isFocused
            ? "shadow-[1px_3px_3px_1px_#182529] -translate-y-2"
            : "shadow-lg"
        } ${
          !negativeSale && product.qty_available <= 0
            ? "opacity-50 pointer-events-none"
            : "opacity-100"
        }`}
      >
        {/* Checkbox Top-Right */}
        {isSelectActive && (
          <button
            onClick={onSelectToggle}
            // className={`absolute top-2 right-2 w-6 h-6 rounded-full border flex items-center justify-center cursor-pointer transition-colors duration-200 z-50 ${isSelected ? "bg-green-500 border-green-500" : "bg-gray-200 border-gray-400"
            //   }`}
            className={`absolute top-2 ${
              i18n.language === "ar" ? "left-2" : "right-2"
            } 
              w-6 h-6 rounded-full border flex items-center justify-center 
              cursor-pointer transition-colors duration-200 z-50 
              ${
                isSelected
                  ? "bg-green-500 border-green-500"
                  : "bg-gray-200 border-gray-400"
              }`}
          >
            {isSelected && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="white"
              >
                <path d="M20.285 6.709l-11.285 11.291-5.285-5.291 1.414-1.414 3.871 3.879 9.871-9.875z" />
              </svg>
            )}
          </button>
        )}

        {showFav && !isSelectActive && !product?.hamper_id && (
          <button
            id={`favBtn-${product?.prod_id}`}
            onClick={toggleFavorite}
            disabled={loading}
            style={{
              position: "absolute",
              top: "0.25rem",
              right: i18n.language === "ar" ? "auto" : "0.25rem",
              left: i18n.language === "ar" ? "0.25rem" : "auto",
              zIndex: 50,
              outline: "none",
              border: "none",
              background: "transparent",
              cursor: "pointer",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill={product.is_favorite ? "gold" : "grey"}
            >
              <path
                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 
      9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
              />
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </button>
        )}

        {product?.hamper_id && 
         <button
    id={`infoBtn-${product?.prod_id}`}
    onClick={() => openProductInfo(product)}   // <-- your handler
    disabled={loading}
    style={{
      position: "absolute",
      top: "0.25rem",
      right: i18n.language === "ar" ? "auto" : "0.25rem",
      left: i18n.language === "ar" ? "0.25rem" : "auto",
      zIndex: 50,
      outline: "none",
      border: "none",
      background: "transparent",
      cursor: "pointer",
    }}
  >
   <img
                  src={info_icon}
                  alt="info"
                  className="w-6 h-7 object-contain"
                />
  </button>}

        <div
          onClick={onClick}
          className="relative flex flex-col p-1 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-500 ease-in-out cursor-pointer h-full"
        >
          <div className="flex justify-center items-center p-2 pt-3 rounded-md ">
            <Badge
              style={{
                position: "absolute",
                top: "0.5rem", // top-2 ≈ 8px
                left: i18n.language === "ar" ? "auto" : "0.5rem",
                right: i18n.language === "ar" ? "0.5rem" : "auto",
                backgroundColor:
                  product.qty_available <= 0 ? "#dc2626" : "#065f46", // red-600 / green-800
                color: "white",
                fontWeight: "600",
                padding: "0.1rem 0.25rem", // px-1
                borderRadius: "0.375rem", // rounded
                fontSize: "0.875rem", // ~text-sm
                lineHeight: "1.25rem",
                zIndex: 10,
              }}
            >
              {i18n.language === "ar" && parseFloat(product.qty_available) < 0
                ? `${parseFloat(-product.qty_available).toFixed(2)}-`
                : parseFloat(product.qty_available).toFixed(2)}
            </Badge>
            {product.image_url ? (
              <img
                loading="lazy"
                src={product.image_url}
                className="h-24 w-auto object-contain cursor-pointer"
                alt={""}
              />
            ) : (
              <img
                loading="lazy"
                src={dummy_image}
                className="h-24 w-auto object-contain cursor-pointer"
                alt={""}
              />
            )}
          </div>
          <div className="text-sm font-semibold text-gray-800 line-clamp-2">
            {product.pack_id ? product.pack_name : product.name}
          </div>
          <div className="flex-grow" />
          <div className=" flex justify-between items-center mt-1 text-sm font-bold text-blue-900 mb-0">
            <span>EGP{" "}
            {productTax?.tax_id && productTax?.is_tax_price_inclusive == false && showAddedExclusivePrice && isETAenabled ? (totalProductTax + product.sale_price)?.toFixed(2)  : (product.pack_id
              ? product.pack_price?.toFixed(2)
              : product.sale_price?.toFixed(2))}
              </span>
              {!product?.hamper_id && 
         <button
    id={`infoBtn-${product?.prod_id}`}
    onClick={() => setExpiryModal(true)}   // <-- your handler
    disabled={loading}
    style={{
      // position: "absolute",
      // top: "0.25rem",
      // right: i18n.language === "ar" ? "auto" : "0.25rem",
      // left: i18n.language === "ar" ? "0.25rem" : "auto",
      // zIndex: 50,
      outline: "none",
      border: "none",
      background: "transparent",
      cursor: "pointer",
    }}
  >
   <img
                  src={info_icon}
                  alt="info"
                  className="w-6 h-6 object-contain"
                />
  </button>}
          </div>
        </div>
        <HamperInfoModal
  open={openInfoModal}
  selectedHamper={selectedHamper}
  onClose={() => setOpenInfoModal(false)}
  addHamper={onClick}
/>
<ProductExpiryModal 
  open={expiryModal}
  onClose={() => setExpiryModal(false)}
  id={product?.prod_id}
/>
      </div>
    </>
  );
};

const ProductRow = ({
  onSelectProduct,
  products,
  focusedProductIndex,
  isSelectActive,
  selectedGroupProducts,
  onSelectToggle,
  activeGroupId,
  onLoadMore,        // new: callback to trigger next page fetch in parent
  hasMore,           // new: boolean — false when no more pages
  isLoadingMore,     // new: boolean — true while parent is fetching
  isFavouriteProd,
}) => {
  const rowRef = useRef(null);
  const loaderRef = useRef(null);
  const { t, i18n } = useTranslation();

  // Scroll focused product into view
  useEffect(() => {
    if (
      rowRef.current &&
      focusedProductIndex !== null &&
      focusedProductIndex !== undefined
    ) {
      const focusedProduct = rowRef.current.children[focusedProductIndex];
      if (focusedProduct) {
        focusedProduct.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }
  }, [focusedProductIndex]);
console.log("isFavouriteProd==>",isFavouriteProd);

  // Infinite scroll: observe the loader sentinel
  useEffect(() => {
    if (!loaderRef.current || !onLoadMore || !isFavouriteProd) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && hasMore && !isLoadingMore) {
          onLoadMore();
        }
      },
      {
        root: rowRef.current,   // scroll container is the root
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    observer.observe(loaderRef.current);
    return () => observer.disconnect();
  }, [hasMore, isLoadingMore, onLoadMore, isFavouriteProd]);

  const deviceType = detectWebDeviceType();

  
  return (
    <div
      ref={rowRef}
      className={`flex flex-wrap custom-scrollbar overflow-y-scroll scrollbar-hidden ${
        deviceType === "tablet"
          ? "max-h-[83vh] md:max-h-[83vh] xl:max-h-[83vh] lg:max-h-[90vh]"
          : "max-h-[93vh] md:max-h-[93vh] xl:max-h-[93vh] lg:max-h-[94vh]"
      }`}
    >
      {products?.map((product, idx) => (
        <ProductCard
          key={product?.prod_id ?? idx}   // prefer stable key over index
          product={product}
          onClick={() => onSelectProduct(product)}
          isFocused={idx === focusedProductIndex}
          isSelectActive={isSelectActive}
          isSelected={selectedGroupProducts?.includes(product?.prod_id)}
          onSelectToggle={() => onSelectToggle(product)}
          activeGroupId={activeGroupId}
        />
      ))}

      {/* Sentinel + loader — always rendered so observer can attach */}
      {isFavouriteProd && 
       <div ref={loaderRef} className="w-full flex justify-center py-4">
        {!hasMore && products?.length > 0 ? (
          <p className="text-base text-gray-300">{t("All products loaded")}</p>
        ): <div className="flex items-center gap-2 text-base text-gray-400">
            <svg
              className="animate-spin h-7 w-7 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12" cy="12" r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v8H4z"
              />
            </svg>
            {t("Loading more...")}
          </div>}
      </div>}

     
    </div>
  );
};

const ProductGrid = ({
  searchValue,
  onSelectProduct,
  products,
  focusedProductIndex,
  productsLoading,
  isSelectActive,
  setSelectedGroupProducts,
  selectedGroupProducts,
  activeGroupId,
     onLoadMore,
      hasMore,
      isLoadingMore,
      isFavouriteProd,
}) => {
  const { t, i18n } = useTranslation();
  const deviceType = detectWebDeviceType();
  const allowAddProduct = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_allow_add_product,
  );
  // const [selectedProducts, setSelectedProducts] = useState([]);

  useEffect(() => {
    if (!isSelectActive) {
      setSelectedGroupProducts([]);
    }
  }, [isSelectActive]);

  const handleSelectProductToggle = (product) => {
    setSelectedGroupProducts((prev) =>
      prev.includes(product.prod_id)
        ? prev.filter((id) => id !== product.prod_id)
        : [...prev, product.prod_id],
    );
  };

  const NoProductsFound = () => {
    if (products.length === 0 && productsLoading === false) {
      return (
        <div className="justify-center text-center mt-32 font-semibold text-lg text-gray-600">
          {t("Product Not Found")}
          <br />
          {!activeGroupId && allowAddProduct && (
            <button
              type="button"
              className="mt-5 bg-green-500 text-white font-semibold rounded-lg w-48 h-12" // Adjust width and height here
            >
              <Link
                to={{
                  pathname: "/pos/InventoryUpdate",
                }}
                state={{ searchValue: searchValue }}
                className="text-white"
                style={{
                  textDecoration: "none",
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {t("Add Product")}
              </Link>
            </button>
          )}
        </div>
      );
    }
  };

  useEffect(() => {
    NoProductsFound();
  }, []);

  return (
    <div className="p-1">
      {products.length === 0 && productsLoading === false ? (
        <NoProductsFound />
      ) : (
        <>
          <ProductRow
            onSelectProduct={onSelectProduct}
            products={products}
            focusedProductIndex={focusedProductIndex}
            isSelectActive={isSelectActive}
            selectedGroupProducts={selectedGroupProducts}
            onSelectToggle={handleSelectProductToggle}
            activeGroupId={activeGroupId}
               onLoadMore={onLoadMore}
      hasMore={hasMore}
      isLoadingMore={isLoadingMore}
      isFavouriteProd={isFavouriteProd}
          />
        </>
      )}
    </div>
  );
};

export default ProductGrid;
